import React from 'react';

import { getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';

export const iframeRef = React.createRef<HTMLIFrameElement>();

export const brokerOrigin = process.env.NODE_ENV === 'development' ? 'http://localhost:5174' : getTjenesterUrl();
export const iframeSrc = `${brokerOrigin}/Core/CrossDomain/Broker`;

export const messageRepresentationChange = (): void => {
  iframeRef.current?.contentWindow?.postMessage(
    {
      type: 'representation-updated',
      timestamp: Date.now().toString(),
    },
    brokerOrigin
  );
};

export const messageAwaken = (): void => {
  iframeRef.current?.contentWindow?.postMessage(
    {
      type: 'awaken',
    },
    brokerOrigin
  );
};
